import { Tracking } from '../tracking';
import { Action, DataContainer, Feature } from '@otto-ec/tracking-bct';

export abstract class Component {
    private tracking: Tracking;

    public constructor(tracking: Tracking) {
        this.tracking = tracking;
    }

    public abstract variationChanged(): void;

    protected trackEvent(dataContainer: DataContainer, action?: Action) {
        this.tracking.trackEvent(dataContainer, action);
    }

    protected trackView(dataContainer: DataContainer, features?: Feature[]) {
        this.tracking.trackView(dataContainer, features);
    }
}
